module.exports = __webpack_public_path__ + "static/img-2-mobile-6a740f26b5c718ec32f9985234c13841.jpg";